import React, { useState, useCallback } from "react"
import Button from "./Button"
import cx from "classnames"
import BlurHandler from "./BlurHandler"

export default function ButtonConfirm(props) {
    const [confirm, setConfirm] = useState(false)

    const {
        className,
        clear,
        disabled,
        danger,
        block,
        spaceRight,
        spaceLeft,
        dark,
        accent,
        lime,
        red,
        mint,
        solid,
        icon,
        onConfirmClick,
        onClick,
        text,
        children,
        style,
    } = props

    const cn = cx(
        "dna-button",
        className,
        {
            "dna-button-clear": clear,
            "dna-button-disabled": disabled,
            "dna-danger-button": danger,
            "dna-button-block": block,
            "dna-space-right": spaceRight,
            "dna-space-left": spaceLeft,
            clear,
            "dna-dark-button": dark,
            "dna-accent-button": accent,
            "lime-button": lime,
            "dna-red-button": red,
            "dna-mint-button": mint,
            solid,
            "has-svg": icon,
            "confirm-it": confirm,
        },
        "dna-confirm-button",
    )

    const handleParentClick = useCallback(
        (e) => {
            e.stopPropagation()
            setConfirm(true)
            if (onConfirmClick) {
                onConfirmClick()
            }
        },
        [onConfirmClick],
    )

    const handleConfirm = useCallback(
        (e) => {
            e.stopPropagation()
            setConfirm(false)
            if (onClick) {
                onClick(e)
            }
        },
        [onClick],
    )

    return (
        <BlurHandler
            onBlur={() => {
                setConfirm(false)
            }}
        >
            <div className={cn} onClick={handleParentClick} style={style}>
                {children}
                <Button className="x-confirm-under-button" onClick={handleConfirm}>
                    {text || "You sure?"}
                </Button>
            </div>
        </BlurHandler>
    )
}
